import { RemoteObjectStore } from '@softline/core';
import {CountryCode} from '../types/country-code';


export const CountryCodeStore = RemoteObjectStore.create<CountryCode[]>();
